import { lazy, ComponentType } from 'react';

// Lazy load all route components for code splitting
export const GuestLandingPage = lazy(() => import('@/pages/GuestLandingPage'));
/** @alias GuestLandingPage */
export const LandingPage = GuestLandingPage;

// Auth pages
export const LoginPage = lazy(() => import('@/pages/auth/LoginPage'));
export const SignupPage = lazy(() => import('@/pages/auth/SignupPage'));
export const VerifyPage = lazy(() => import('@/pages/auth/VerifyPage'));
export const CreateProfilePage = lazy(() => import('@/pages/auth/CreateProfilePage'));
export const ResetPasswordPage = lazy(() => import('@/pages/auth/ResetPasswordPage'));

// Dashboard pages
export const DashboardPage = lazy(() => import('@/pages/dashboard/DashboardPage'));
export const SettingsPage = lazy(() => import('@/pages/dashboard/SettingsPage'));
export const SupportPage = lazy(() => import('@/pages/dashboard/SupportPage'));

// Demo page
export const ComponentsDemo = lazy(() => import('@/pages/ComponentsDemo'));

// Layouts
export const AuthLayout = lazy(() => import('@/layouts/AuthLayout'));
export const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));

// Preloading strategies for better performance
export const preloadRoute = (component: ComponentType<any>) => {
  // Preload component when needed (e.g., on hover, focus, or navigation)
  return () => {
    // This will trigger the lazy loading
    component;
  };
};

// Preload critical routes on app initialization
export const preloadCriticalRoutes = () => {
  // Preload auth layout since it's commonly accessed
  AuthLayout;
  // Preload dashboard layout for authenticated users
  DashboardLayout;
};

// Preload routes based on user interaction
export const preloadAuthRoutes = () => {
  LoginPage;
  SignupPage;
};

export const preloadDashboardRoutes = () => {
  DashboardPage;
  SettingsPage;
  SupportPage;
};
